import {charcoal} from '../sass/base/_exports.sass';

export const LocationAddressNavigationLineIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.66669 6.66669L12 2.66669L20 6.66669L28.404 3.06535C28.5055 3.02187 28.6161 3.00425 28.7261 3.01408C28.836 3.02391 28.9418 3.06088 29.0339 3.12168C29.126 3.18248 29.2016 3.2652 29.2539 3.36242C29.3061 3.45964 29.3335 3.56831 29.3334 3.67869V25.3334L20 29.3334L12 25.3334L3.59602 28.9347C3.49457 28.9782 3.38391 28.9958 3.27397 28.986C3.16404 28.9761 3.05826 28.9392 2.96614 28.8784C2.87401 28.8176 2.79843 28.7348 2.74616 28.6376C2.6939 28.5404 2.66659 28.4317 2.66669 28.3214V6.66669ZM21.3334 25.86L26.6667 23.5747V6.71069L21.3334 8.99602V25.86ZM18.6667 25.6854V8.98135L13.3334 6.31469V23.0187L18.6667 25.6854ZM10.6667 23.004V6.14002L5.33335 8.42535V25.2894L10.6667 23.004Z"
        fill={color}
      />
    </svg>
  );
};
